import { useEffect, useState } from "react";
import { Button } from "react-aria-components";
import IconPlus from "../../../../../assets/icons/icon-plus-blue.svg";
import SpecimensModal from "../../../Modal/SpecimensModal";
import { modalSignal } from "../../../Modal/ModalContainer";

interface IFormSpecimens {
    value: any
    label: string
    entityName: string
    required: boolean
    onChange: Function
    disabled?: boolean
}

export interface ISpecimen {
    id: string | undefined | null,
    code: string | undefined,
    quantity: number | undefined
}

export default function FormSpecimens({ value, disabled, label, entityName, required, onChange }: IFormSpecimens) {
   
    function isDisabled() {
        return disabled ?? false
    }

    async function getData() {
        try {
        }
        catch (err) {
        }
    }

    function handleDoneWithSpecimens(specimens: ISpecimen[]) {
        onChange(specimens);
    }

    function handlePlusSpecimensClicked() {
        modalSignal.value = <SpecimensModal 
            heading="Add / edit specimens"
            information="Specimens will be saved when you add / save the case"
            ContinueFunc={handleDoneWithSpecimens}
            existingSpecimens={value ?? []}
        />
    }

    function getSpecimenLabel() {
        const specimens = value ?? [];
        const suffix = specimens.length === 1 ? '' : 's';
        return `${specimens.length} specimen${suffix}`;
    }

    useEffect(() => {
        getData()
    }, [])

    return (<>
        <hr></hr>
        <div className="form-specimens__wrapper">
            <Button
                isDisabled={isDisabled()}
                className={"button button--secondary button--with-icon button--extra-small"}
                onPress={handlePlusSpecimensClicked}>
                <img src={IconPlus}></img>
                <p className="button-text button-text--small">{getSpecimenLabel()}</p>
            </Button>
        </div>
    </>)
}